/**
 * Business plane path guard — subdomain read caps (TP-G26 · D23)
 * Complements useMenuVisibility sidebar filter; blocks direct URL access.
 */

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ForbiddenReasonPanel } from '@shared/ui/ForbiddenReasonPanel';
import { useMenuVisibility } from '../hooks/ui/useMenuVisibility';
import { resolveBusinessMenuFallbackPath } from '@shared/site/business-menu-rbac';

export const BusinessPathGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { canAccessPath, visibleDomainKeys } = useMenuVisibility();
  const pathname = location.pathname;

  if (!canAccessPath(pathname)) {
    const fallbackPath = resolveBusinessMenuFallbackPath(visibleDomainKeys);
    const links =
      visibleDomainKeys.length > 0
        ? [{ label: '허용된 메뉴로 이동', href: fallbackPath, primary: true as const }]
        : [];

    return (
      <ForbiddenReasonPanel
        links={links}
        onNavigate={(href) => navigate(href, { replace: true })}
      />
    );
  }

  return <>{children}</>;
};

export default BusinessPathGuard;
